import script from "./ChiTietCongTrinh.vue?vue&type=script&setup=true&lang=js"
export * from "./ChiTietCongTrinh.vue?vue&type=script&setup=true&lang=js"

import "./ChiTietCongTrinh.vue?vue&type=style&index=0&id=3f00c628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f00c628"]])

export default __exports__